import { createSlice } from "@reduxjs/toolkit";
import { boolean } from "yup";

const initialState = {
  getSetting: [],
  partnerData: [],
  loginData: [],
  getCommisionsData: [],
  graphData : false,
  graphShow : false,
  graphValues:[],
  saveWebsiteProfileData: {
    WebsiteModalShow: false,
    AddWebsiteModel: false,
    DomainAllotmentModal: false,
  },
  agentBusinessCount: {
    total_business: 0,
    total_agents: 0,
  },
  partnerProfileData: {
    AllData: "",
    country_currency_info: "",
    partner_profile: "",
    popups: "",
    stripe_data: "",
    partner_domains: [],
  },
  courseData: [],
  getCoachMark:true,
};

export const MainSlice = createSlice({
  name: "APIData",
  initialState,
  reducers: {
    saveSettingData: (state: any, action: any) => {
      // console.log("state", state, "action", action);
      state.getSetting = action.payload;
    },
    savePartnerData: (state, action) => {
      state.partnerData = action.payload;
    },
    saveWebsiteData: (state, action) => {
      state.saveWebsiteProfileData = action.payload;
    },
    saveAgentBusinessCount: (state, action) => {
      state.agentBusinessCount = action.payload;
    },
    savePartnerProfileData: (state, action) => {
      state.partnerProfileData = action.payload;
    },
    saveCourseData: (state, action) => {
      state.courseData = action.payload;
    },
    showGraph: (state, action) => {
      state.graphData = action.payload;
    },
    showGraphValues: (state, action) => {
      state.graphValues = action.payload;
    },
    showdropdown: (state, action) => {
      state.graphShow = action.payload;
    },
    saveCommisiondata: (state, action) => {
      state.getCommisionsData = action.payload;
    },
    showCoachMark: (state, action) => {
      state.getCoachMark = action.payload;
    },
  },
});

const assestsDataSlice = createSlice({
  name: "assetsData",
  initialState: {
    showAssets: false,
    shimmer: false,
    showSelectedFolderData: [],
    addAssestsFolder: [],
    getAssetData: [],
  },
  reducers: {
    setShowAssets: (state, action) => {
      state.showAssets = action.payload;
    },
    setShowSelectedFolderData: (state, action) => {
      state.showSelectedFolderData = action.payload;
    },
    setAddAssestsFolder: (state, action) => {
      state.addAssestsFolder = action.payload;
    },
    setGetAssetData: (state, action) => {
      state.getAssetData = action.payload;
    },
    setShimmerImg: (state, action) => {
      state.shimmer = action.payload;
    },

    
    
  },
});

export const {
  setShowAssets,
  setShowSelectedFolderData,
  setAddAssestsFolder,
  setGetAssetData,
  setShimmerImg,
} = assestsDataSlice.actions;

export const {
  saveSettingData,
  savePartnerData,
  saveWebsiteData,
  saveAgentBusinessCount,
  savePartnerProfileData,
  saveCourseData,
  showGraph,
  showGraphValues,
  showdropdown,
  saveCommisiondata,showCoachMark
} = MainSlice.actions;

export default MainSlice.reducer;
export const AssetsReducer = assestsDataSlice.reducer;
